class MoveBookingOptions {

    constructor() {
        'ngInject';
        this.options = {
            confirmationRoute: 'public-booking/_templates/steps/confirmation',
            askMoveReasons: false,
            moveReasonRoute: 'public-booking/_templates/steps/reschedule_reasons'
        };
    }

    setOption(option, value) {
        if (this.options.hasOwnProperty(option)) {
            this.options[option] = value;
        }
    }

    $get() {
        return this.options;
    }
}

angular
    .module('BB')
    .provider('MoveBookingOptions', MoveBookingOptions);




// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/move-booking/move_booking_options.provider.js